import React, { useEffect, useMemo } from 'react';
import {
  Box, Typography, makeStyles, Paper,
} from '@material-ui/core';
import { connect } from 'react-redux';
import gifSuccess from '../../../assets/img/marketPlace/Check_success.gif';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
    padding: theme.spacing(2),
  },
  succesCard: {
    backgroundColor: theme.body.successCard.backgroundColor,
    borderRadius: '20px',
    padding: theme.spacing(5),
    textAlign: 'center',
    boxShadow: `0px 10px 25px ${theme.body.successCard.boxShadow}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: '4.5rem',
    color: theme.body.successCard.icon,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    color: theme.body.successCard.title,
    fontSize: 28,
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    fontFamily: '"Karla"',
  },
  description: {
    color: theme.body.successCard.description,
    marginBottom: '12px',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontFamily: '"Karla"',
  },
}));

const PaymentResult = (props) => {
  const { onReady, paymentResult, getParametersMarket } = props;
  const classes = useStyles();

  const redirectUrl = useMemo(() => {
    if (getParametersMarket?.length > 0) {
      return getParametersMarket.find(
        (currentParam) => currentParam.parameterCode === 'Catalog_Url',
      )?.parameterValue;
    }
    return '';
  }, [getParametersMarket]);

  useEffect(() => {
    if (
      paymentResult?.succesfullMessage
      && paymentResult?.description
      && paymentResult?.statusCode
      && redirectUrl
    ) {
      if (paymentResult?.statusCode === 200) {
        onReady();
      } else if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
  }, [paymentResult, onReady, redirectUrl]);

  return (
    <Box className={classes.container}>
      <Paper elevation={0} className={classes.succesCard}>
        <img
          src={gifSuccess}
          alt="Succes icon"
          style={{
            width: 120,
            height: 120,
          }}
        />
        <Typography variant="h2" className={classes.title}>
          {paymentResult?.succesfullMessage}
        </Typography>
        <Typography className={classes.description}>
          {paymentResult?.description}
        </Typography>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (props) => ({
  paymentResult: props.license.paymentResult,
  getParametersMarket: props.general.getParametersMarket,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentResult);
